import { render } from "./ProfileSessions.vue?vue&type=template&id=64f34bc2"
import script from "./ProfileSessions.vue?vue&type=script&lang=js"
export * from "./ProfileSessions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__